import React from 'react';
import { IconProps } from '../types';

export const PublicationIcon = ({ color }: IconProps) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.0001 29.3344V6.66771H17.0001V29.3344H15.0001Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.6666 4.41229C29.6666 4.1925 29.4576 4.03287 29.2455 4.0907L15.9999 7.70315L2.75429 4.0907C2.54224 4.03287 2.33325 4.1925 2.33325 4.41229V24.3149C2.33325 24.4652 2.43386 24.5969 2.57888 24.6365L15.9999 28.2968L29.421 24.6365C29.566 24.5969 29.6666 24.4652 29.6666 24.3149V4.41229ZM28.7193 2.16117C30.2036 1.75636 31.6666 2.87375 31.6666 4.41229V24.3149C31.6666 25.3671 30.9623 26.2892 29.9472 26.566L15.9999 30.3698L2.05264 26.566C1.0375 26.2892 0.333252 25.3671 0.333252 24.3149V4.41229C0.333252 2.87375 1.7962 1.75636 3.28053 2.16118L15.9999 5.6301L28.7193 2.16117Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.7075 9.29804L28.374 6.44505L28.295 14.4972L18.6259 17.7563L18.7075 9.29804ZM20.6103 10.7654L20.5688 15.0664L26.3918 13.1037L26.4316 9.04726L20.6103 10.7654Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.6135 20.381L19.1742 21.5699L18.5207 19.6797L21.96 18.4908L22.6135 20.381Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.6135 24.5653L19.1742 25.7542L18.5207 23.864L21.96 22.675L22.6135 24.5653Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.0095 18.8507L24.5702 20.0396L23.9168 18.1494L27.3561 16.9604L28.0095 18.8507Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.0095 22.6604L24.5702 23.8493L23.9168 21.9591L27.3561 20.7701L28.0095 22.6604Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.6519 19.7136L3.9836 17.3698L4.75355 15.5239L13.4219 17.8677L12.6519 19.7136Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.6519 15.9038L3.9836 13.5601L4.75355 11.7142L13.4219 14.058L12.6519 15.9038Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.6519 12.0941L3.9836 9.75034L4.75355 7.90448L13.4219 10.2483L12.6519 12.0941Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.74708 22.1971L3.9836 21.1795L4.75355 19.3337L8.51703 20.3512L7.74708 22.1971Z"
            fill={color}
        />
    </svg>
);
